import { Modal, Card } from "@mui/material";
import Button from "@mui/material/Button";
import { useEffect, useRef, useState } from "react";
import AllDataClass from "../common/AllDataClass";

import "./ResultViewPlan.scss";
import { useTranslation } from "react-i18next";
import YoungSad from "../../images/young_sad.png";
import YoungHappy from "../../images/young_happy.png";
import OldSad from "../../images/old_sad.png";
import OldHappy from "../../images/old_happy.png";

type ModalProp = {
  open: boolean;
  handleClose: () => void;
  selectedGoals: any[];
  selectedPolicyLists: any;
  debt: any[];
  starScore: any[];
  gameid: string;
  username: string;
  pyi: number;
  policyImpact: any[];
};

const ViewPlan = ({
  open,
  handleClose,
  selectedGoals,
  selectedPolicyLists,
  debt,
  starScore,
  gameid,
  username,
  pyi,
  policyImpact,
}: ModalProp) => {
  // console.log(selectedPolicyLists);
  if (!selectedGoals) return;
  const maxPolicyCnt = 8;
  // const [selectedPolicyLists, setSelectedPolicyLists] = useState([]);
  const { t } = useTranslation();
  const [viewPlanModalOpen, setViewPlanModalOpen] = useState(false);
  const [policyData, setPolicyData] = useState({});
  const [policyCnt, setPolicyCnt] = useState(0);
  // const [pageCnt, setPageCnt] = useState(0);
  const [curPage, setCurPage] = useState(0);
  const [showPolicies, setShowPolicies] = useState(["1"]);
  const [isFirst, setIsFirst] = useState(true);
  const [fullMeetCnt, setFullMeetCnt] = useState(0);
  const [partialMeetCnt, setpartialMeetCnt] = useState(0);

  // const [policyImpact, setPolicyImpact] = useState(
  //   AllDataClass.getPolicyGovGoalImpactsForGoals(selectedPolicyLists)
  // );

  const getGoalScore = () => {
    var retVal = true;
    starScore.forEach((score) => {
      retVal = retVal && score >= 3;
    });
    return retVal;
  };

  console.log(isFirst);
  console.log(selectedPolicyLists);
  console.log(showPolicies);
  console.log(curPage);
  console.log(AllDataClass.getPolicyGovGoalImpactsForGoals(selectedPolicyLists));
  const pageCnt =
    selectedPolicyLists.length % maxPolicyCnt == 0
      ? Math.floor(selectedPolicyLists.length / maxPolicyCnt) - 1
      : Math.floor(selectedPolicyLists.length / maxPolicyCnt);
  const debtGoalMeet = debt[debt.length - 1] <= 150;
  const GoalMeet = getGoalScore();
  useEffect(() => {
    var polycnt = selectedPolicyLists.length;
    console.log("##############", polycnt);
    setPolicyCnt(selectedPolicyLists.length);
    // setPageCnt(Math.floor(polycnt / maxPolicyCnt));
    setCurPage(0);
    setShowPolicies(selectedPolicyLists?.slice(0, maxPolicyCnt));
  }, []);
  useEffect(() => {
    setPolicyCnt(selectedPolicyLists.length);
    // setPageCnt(Math.floor(policyCnt / maxPolicyCnt));
    setCurPage(0);
    setShowPolicies(selectedPolicyLists?.slice(0, maxPolicyCnt));
    console.log(AllDataClass.getSelectedList());
  }, [selectedPolicyLists]);
  const AllPolicies = AllDataClass.getPolicyDescriptives();
  // if (isFirst === true && AllDataClass.getSelectedList()) {
  //   setIsFirst(false);
  //   console.log(AllDataClass.getSelectedList());
  //   // setSelectedPolicyLists(AllDataClass.getSelectedList());
  //   setPolicyCnt(selectedPolicyLists.length);
  //   setPageCnt(Math.floor(policyCnt / maxPolicyCnt));
  //   setCurPage(0);
  //   console.log(pageCnt);
  //   if (pageCnt > 0) {
  //     setShowPolicies(selectedPolicyLists?.slice(0, maxPolicyCnt));
  //   } else {
  //     setShowPolicies(selectedPolicyLists);
  //   }
  // }

  useEffect(() => {
    console.log(curPage);
    if (selectedPolicyLists.length > curPage * maxPolicyCnt) {
      console.log("refresh show lists");
      setShowPolicies(
        selectedPolicyLists?.slice(curPage * maxPolicyCnt, curPage * maxPolicyCnt + maxPolicyCnt)
      );
    }
  }, [curPage]);

  if (showPolicies[0] === "1") {
    console.log(selectedPolicyLists);
    // setSelectedPolicyLists(AllDataClass.getSelectedList());
    setPolicyCnt(selectedPolicyLists.length);
    // setPageCnt(Math.floor(policyCnt / maxPolicyCnt));
    setIsFirst(true);
    // setCurPage(0);
    console.log(pageCnt);
    if (pageCnt > 0) {
      setShowPolicies(selectedPolicyLists?.slice(0, maxPolicyCnt));
    } else {
      setShowPolicies(selectedPolicyLists);
    }
  }

  const closeModal = () => {
    // setSelectedPolicyLists([]);
    setShowPolicies([]);
    setIsFirst(true);
    handleClose();
  };

  const clickPrevBtn = () => {
    console.log("clickPrevBtn");
    if (curPage > 0) {
      setCurPage(curPage - 1);
    }
    if (selectedPolicyLists.length > curPage * maxPolicyCnt) {
      setShowPolicies(selectedPolicyLists?.slice(0, maxPolicyCnt));
    }
  };
  const clickNextBtn = () => {
    console.log("clickNextBtn");
    if (curPage < pageCnt && curPage >= 0) {
      setCurPage(curPage + 1);
    }
    if (selectedPolicyLists.length > curPage * maxPolicyCnt) {
      setShowPolicies(selectedPolicyLists?.slice(0, maxPolicyCnt));
    }
  };

  const handleCopyClipBoard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("copied");
    } catch (e) {
      alert("failed");
    }
  };

  const closePlan = () => {
    handleClose();
    setCurPage(0);
  };

  const viewPlainGoalList = () => {
    var goal_list = new Array();
    var points = starScore;

    selectedGoals.map((selectedGoal: any, idx: number) => {
      var starPoint = points[idx];

      goal_list.push(
        <div className={`goal-image ${selectedGoal.goalid}`} key={idx}>
          {starPoint >= 1 && <div className="viewplan-goal-star1" />}
          {starPoint >= 3 && <div className="viewplan-goal-star2" />}
          {starPoint >= 4 && <div className="viewplan-goal-star3" />}
        </div>
      );
    });
    return goal_list;
  };

  const getGoalImpact = (policyid: any) => {
    var impact_list = new Array();
    if (selectedPolicyLists.length <= 0) return impact_list;
    selectedGoals.map((selectedGoal: any, idx: number) => {
      var goalIdx = Number(selectedGoal.goalid.substring(1));
      var impact = policyImpact[policyid][0][goalIdx];
      var classname = "";
      if (impact == 1) {
        classname = "smallup";
      } else if (impact == 2) {
        classname = "bigup";
      } else if (impact == -1) {
        classname = "smalldown";
      } else if (impact == -2) {
        classname = "bigdown";
      } else {
        classname = "none";
      }
      impact_list.push(
        <div className={`impact ${classname} ${selectedGoal.goalid}`} key={idx}></div>
      );
    });
    return impact_list;
  };

  const checkGoalMeet = () => {
    var retVal = true;
    var fullmeet = 0;
    var partialmeet = 0;
    starScore.forEach((score) => {
      if (score >= 4) {
        retVal = retVal && true;
        fullmeet++;
        partialmeet++;
      } else if (score >= 3) {
        partialmeet++;
      } else {
        retVal = false;
      }
    });

    return (
      <div className="explain">
        {fullmeet == 3
          ? t("goal-full-meet-text")
          : partialmeet == 3
            ? t("goal-partial-meet-text")
            : t("goal-fail-text")}
      </div>
    );
    // return retVal;
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="result-viewplan-modal-main"
      >
        <div className="viewplan-modal">
          <div className="viewplan-background" />
          <div className="viewplan-modal-content">
            <div className="plan-explain">
              <div className="plan-explain-title-wrap">
                <div className={`plan-explain-title ${!debtGoalMeet && "fail"}`}>
                  <span>
                    {debtGoalMeet
                      ? t("debtgoal-meet")
                          .split("\n")
                          .map((item: any, idx: number) => <div key={idx}>{item}</div>)
                      : t("debtgoal-fail")
                          .split("\n")
                          .map((item: any, idx: number) => <div key={idx}>{item}</div>)}
                  </span>
                </div>
                <div className={`plan-explain-title ${!GoalMeet && "fail"}`}>
                  <span>
                    {GoalMeet
                      ? t("goal-meet")
                          .split("\n")
                          .map((item: any, idx: number) => <div key={idx}>{item}</div>)
                      : t("goal-fail")
                          .split("\n")
                          .map((item: any, idx: number) => <div key={idx}>{item}</div>)}
                  </span>
                </div>
              </div>
              <div className="plan-explain-contents">
                <div className="row-wrap">
                  <div className="bullet" />
                  <div className="explain">
                    {t("debtgoal-text", {
                      debtratio: debt[debt?.length - 1]?.toFixed(1),
                      archive: debt[debt.length - 1] > 150 ? t("archive-fail") : t("archive-meet"),
                    })}
                  </div>
                </div>
                <div className="row-wrap">
                  <div className="bullet" />
                  <div className="explain">
                    {t("PYI-text", {
                      pyi: pyi?.toFixed(1),
                      level:
                        pyi - 31.8 == 0
                          ? t("equal-pyi")
                          : pyi - 31.8 > 0
                            ? t("upper-pyi")
                            : t("lower-pyi"),
                      generation: pyi - 31.8 >= 0 ? t("future-gen") : t("current-gen"),
                    })}
                  </div>
                </div>
                <div className="row-wrap">
                  <div className="pyi-result-wrap">
                    <div className="pyi-result young">
                      <img
                        className="pyi-result-img"
                        src={pyi - 31.8 < 0 ? YoungHappy : YoungSad}
                      />
                    </div>
                    <div className="pyi-result old">
                      <img className="pyi-result-img" src={pyi - 31.8 >= 0 ? OldHappy : OldSad} />
                    </div>
                  </div>
                </div>
                <div className="row-wrap">
                  <div className="bullet" />
                  {checkGoalMeet()}
                  {/* <div className="explain">
                    {fullMeetCnt == 3
                      ? t("goal-full-meet-text")
                      : partialMeetCnt == 3
                        ? t("goal-partial-meet-text")
                        : t("goal-fail-text")}
                  </div> */}
                </div>
              </div>
              <div className="plan-explain-id">
                <div className="saveid">
                  SavelD:&nbsp;
                  <span>{gameid}</span>
                </div>
                <div className="btn-copy-id" onClick={() => handleCopyClipBoard(gameid)}></div>
              </div>
            </div>
            <div className="virtical-bar" />
            <div className="plan-list">
              <div className="plan-list-title">
                {username === "이재명 후보님11" || username === "김문수 후보님11" ? (
                  <span>
                    {username === "이재명 후보님11"
                      ? t("candidate1-detail-res")
                      : t("candidate2-detail-res")}
                  </span>
                ) : (
                  <span>
                    {username}
                    {t("userplan")}
                  </span>
                )}
                <div className="plan-close-btn" onClick={closePlan} />
              </div>
              <div className="plan-lists">
                <div className="goal-wrap">
                  <div className="goals">{viewPlainGoalList()}</div>
                </div>
                <div className="plans">
                  {showPolicies.map((policyid: any, idx: number) => (
                    <div className="row" key={idx}>
                      <div
                        className="bullet"
                        // onClick={() => {
                        //   showSlectedPolicy(policyid);
                        // }}
                      ></div>
                      <div className="policyname">
                        {AllPolicies[policyid] && AllPolicies[policyid][2]}
                      </div>
                      <div className="impacts">{getGoalImpact(policyid)}</div>
                    </div>
                  ))}
                </div>
                <div className="sub-buttons">
                  <button
                    className="view-plan-prev"
                    disabled={curPage == 0}
                    onClick={() => clickPrevBtn()}
                  />
                  <button
                    className="view-plan-next"
                    disabled={curPage == pageCnt}
                    onClick={() => clickNextBtn()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ViewPlan;
